var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeadphones = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "headphones-audio-symbol",
    width: 28.275,
    height: 28.275,
    viewBox: "0 0 28.275 28.275",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x38__20_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M26.453,12.83c.025-.3.055-.6.055-.9A12.155,12.155,0,0,0,14.137,0,12.155,12.155,0,0,0,1.767,11.928c0,.306.03.6.055.9A3.52,3.52,0,0,0,0,15.9v5.3A3.534,3.534,0,0,0,3.534,24.74s3.538,0,3.534,0A3.678,3.678,0,0,0,10.6,21.206V15.9A3.534,3.534,0,0,0,7.069,12.37H3.534a10.583,10.583,0,0,1,10.6-10.6,10.329,10.329,0,0,1,10.6,10.6H21.206A3.534,3.534,0,0,0,17.672,15.9v5.3a3.678,3.678,0,0,0,3.534,3.534c0,.005,1.767,0,1.767,0v2.651a.884.884,0,1,0,1.767,0V24.74h0a3.534,3.534,0,0,0,3.534-3.534V15.9A3.52,3.52,0,0,0,26.453,12.83Zm-20.5,1.307H7.069A1.767,1.767,0,0,1,8.836,15.9v5.3a1.767,1.767,0,0,1-1.767,1.767H6.3a12.276,12.276,0,0,1-1-4.86A12.5,12.5,0,0,1,5.957,14.137Zm-2.423,0h.555a14.675,14.675,0,0,0-.555,3.976,14.461,14.461,0,0,0,.834,4.86H3.534a1.767,1.767,0,0,1-1.767-1.767V15.9A1.767,1.767,0,0,1,3.534,14.137Zm18.443,8.836h-.771a1.767,1.767,0,0,1-1.767-1.767V15.9a1.767,1.767,0,0,1,1.767-1.767h1.112a12.5,12.5,0,0,1,.656,3.976A12.275,12.275,0,0,1,21.977,22.973Zm4.53-1.767a1.767,1.767,0,0,1-1.767,1.767h-.834a14.461,14.461,0,0,0,.834-4.86,14.674,14.674,0,0,0-.555-3.976h.555A1.767,1.767,0,0,1,26.507,15.9Z",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeadphones, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/headphones.6a072851.svg";
export { ForwardRef as ReactComponent };